import Dialog, { DialogProps } from '@liquidweb-dev/undercurrent/Dialog';
import DialogTitle from '@liquidweb-dev/undercurrent/DialogTitle';
import DialogContent from '@liquidweb-dev/undercurrent/DialogContent';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';

export interface DialogDestroyAddonProps extends Omit<DialogProps, 'onClose'> {
	title: string;
	subtitle: string;
	onClose: () => void;
}

const DialogDestroyAddon = ({
	title,
	subtitle,
	children,
	onClose,
	...dialogProps
}: DialogDestroyAddonProps) => {
	return (
		<Dialog maxWidth="md" fullWidth onClose={onClose} {...dialogProps}>
			<DialogTitle onClose={onClose}>
				<Stack gap={100} useFlexGap sx={{ px: 400, pt: 400, pb: 100 }}>
					<Typography fontWeight={500} variant="title-md">
						{title}
					</Typography>
					<Typography variant="body-md" fontWeight={400}>
						{subtitle}
					</Typography>
				</Stack>
			</DialogTitle>
			<DialogContent sx={{ px: 700, pb: 500 }}>{children}</DialogContent>
		</Dialog>
	);
};

export default DialogDestroyAddon;
